import { computed, shallowRef, toValue, watch } from "vue";

import { toBoolean } from "#ce/utils/props";

/** Remounts start-on-root navigation for the next open, and clears the current item. */
export function useContainerReset({ open, disabled, inSheet, startOnRoot, emit }) {
  const containerResetKey = shallowRef(0);
  const startsOnRoot = computed(() => toBoolean(toValue(startOnRoot)));
  let resetPending = toBoolean(toValue(open));
  let isClosing = false;

  function resetWhenClosed() {
    if (toBoolean(toValue(open))) {
      return;
    }

    isClosing = false;

    if (!resetPending) {
      return;
    }

    if (startsOnRoot.value) {
      resetContainer();
    } else {
      resetPending = false;
    }
  }

  function resetContainer() {
    resetPending = false;
    containerResetKey.value++;
    emit("update-current-item", null);
  }

  function noteMenuState([value, starts], [wasOpen, startedOnRoot]) {
    if (value) {
      if (!wasOpen) {
        if (starts && (resetPending || !startedOnRoot)) {
          resetContainer();
        }

        isClosing = false;
        resetPending = true;
      }

      return;
    }

    if (wasOpen) {
      isClosing = true;

      if (toValue(disabled) && !toValue(inSheet)) {
        resetWhenClosed();
      }

      return;
    }

    if (starts && !startedOnRoot && !isClosing) {
      resetContainer();
    }
  }

  watch([open, startsOnRoot], noteMenuState);

  return {
    containerResetKey,
    resetWhenClosed,
  };
}
